/* eslint-disable camelcase */
import { createSlice } from '@reduxjs/toolkit';
import { Post, dateDiffMinutes, getNow } from 'model';

/**
 * This caches the feed order, so that the feed order does not jump between mutations
 */
export interface FeedOrderState {
	lastUpdated: string;
	feedOrder: Array<Post['_id']>;
}

export const feedOrderSlice = createSlice({
	name: 'feedOrder',
	initialState: {
		lastUpdated: '',
		feedOrder: []
	} as FeedOrderState,
	reducers: {
		setFeedOrder: (state, { payload }: { payload: Post[] }) => {
			const now = getNow();
			if (
				(state.feedOrder.length === 0 && payload.length > 0) ||
				state.lastUpdated === '' ||
				dateDiffMinutes(state.lastUpdated, now) > 10
			) {
				state.feedOrder = payload.map(post => post._id);
				state.lastUpdated = now;
			}
		},
		resetFeedOrder: state => {
			state.feedOrder = [];
			state.lastUpdated = '';
		}
	}
});

// Action creators are generated for each case reducer function
export const { setFeedOrder, resetFeedOrder } = feedOrderSlice.actions;
export default feedOrderSlice.reducer;
